import { render } from "./TaxListComponent.vue?vue&type=template&id=640927e9"
import script from "./TaxListComponent.vue?vue&type=script&lang=js"
export * from "./TaxListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Tax/TaxListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "640927e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('640927e9', __exports__)) {
    api.reload('640927e9', __exports__)
  }
  
  module.hot.accept("./TaxListComponent.vue?vue&type=template&id=640927e9", () => {
    api.rerender('640927e9', render)
  })

}


export default __exports__